import { watch } from 'vue';

/**
 * Prefixes the browser tab title with the unread count, e.g. "(3) Chatwoot".
 * Chatwoot already swaps the favicon on unread (see
 * dashboard/helper/AudioAlerts/faviconHelper.js) — this mirrors that in the
 * tab title, which is what an agent actually sees when the dashboard is a
 * background tab.
 *
 * @param {import('vue').Ref<number>} unreadCountRef
 */
export function useUnreadTabTitle(unreadCountRef) {
  const tituloBase = document.title;

  watch(
    unreadCountRef,
    count => {
      document.title = count > 0 ? `(${count}) ${tituloBase}` : tituloBase;
    },
    { immediate: true }
  );
}
